import React, { useEffect, useState } from "react";
import { api } from "@/api";
import { useTranslation } from "react-i18next";
import { CalendarCheck, MessagesSquare, Star, PartyPopper, Utensils } from "lucide-react";

const STAT = ({ icon: Icon, label, value, testId }) => (
  <div className="luxe-card p-6" data-testid={testId}>
    <div className="flex items-center justify-between mb-2">
      <div className="overline">{label}</div>
      <Icon size={18} className="text-[#D4AF37]" />
    </div>
    <div className="font-serif-luxe text-4xl text-[#F8F5EF]">{value}</div>
  </div>
);

export default function Dashboard() {
  const { t } = useTranslation();
  const [stats, setStats] = useState({ reservations: 0, events: 0, messages: 0, reviews: 0, menuItems: 0 });

  useEffect(() => {
    Promise.allSettled([
      api.get("/admin/reservations"),
      api.get("/admin/events"),
      api.get("/admin/contact"),
      api.get("/reviews"),
      api.get("/menu/all"),
    ]).then(([res, ev, ms, rv, mn]) => {
      setStats({
        reservations: res.status === "fulfilled" ? res.value.data.length : 0,
        events: ev.status === "fulfilled" ? ev.value.data.length : 0,
        messages: ms.status === "fulfilled" ? ms.value.data.length : 0,
        reviews: rv.status === "fulfilled" ? rv.value.data.length : 0,
        menuItems: mn.status === "fulfilled" ? mn.value.data.items.length : 0,
      });
    });
  }, []);

  return (
    <div className="p-8 lg:p-12" data-testid="admin-dashboard">
      <div className="overline">Le 17 · Back-office</div>
      <h1 className="font-serif-luxe text-4xl text-[#F8F5EF] mt-2 mb-10">{t("admin.dashboard")}</h1>
      <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-4">
        <STAT icon={CalendarCheck} label={t("admin.reservations")} value={stats.reservations} testId="stat-reservations" />
        <STAT icon={PartyPopper} label={t("admin.events")} value={stats.events} testId="stat-events" />
        <STAT icon={MessagesSquare} label={t("admin.contact")} value={stats.messages} testId="stat-messages" />
        <STAT icon={Star} label={t("admin.reviews")} value={stats.reviews} testId="stat-reviews" />
        <STAT icon={Utensils} label={t("admin.menu")} value={stats.menuItems} testId="stat-menu" />
      </div>
    </div>
  );
}
